import React from 'react';

import MenuCancel from './menu-cancel.jsx';
import SlowConnectionBanner from './slow-connection-banner.jsx';
import SvgIcon from './svg-icon.jsx';

const AUTO_HIDE_DELAY_MS = 3000;

const LEVEL_ICONS = {
  warning: { name: 'warning', viewBox: '0 0 17 17', className: 'icon-warning' },
  error: { name: 'delivery-failed', viewBox: '0 0 15 15', className: 'icon-error' },
  info: { name: 'info-circle', viewBox: '0 0 17 17', className: 'icon-info' },
};

export default class ErrorPanel extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.autoHideTimer = null;

    this.hide = this.hide.bind(this);
  }

  componentDidMount() {
    this.scheduleAutoHide();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.level !== this.props.level || prevProps.text !== this.props.text) {
      this.setState({
        show: !(!this.props.level)
      });
      this.scheduleAutoHide();
    }
  }

  componentWillUnmount() {
    this.clearAutoHide();
  }

  // skip when there's no error, when the error has an actionable link the user is expected to click, or for the slow-connection banner which reflects an ongoing network state.
  scheduleAutoHide() {
    this.clearAutoHide();
    if (!this.props.level || this.props.action || this.props.errorId === 'slow_internet_connection') {
      return;
    }

    this.autoHideTimer = setTimeout(() => {
      this.autoHideTimer = null;
      this.hide();
    }, AUTO_HIDE_DELAY_MS);
  }

  clearAutoHide() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
      this.autoHideTimer = null;
    }
  }

  hide() {
    this.clearAutoHide();
    this.setState({show: false});
    if (this.props.onClearError) {
      this.props.onClearError();
    }
  }

  render() {
    const icons = {err: 'error', warn: 'warning', info: 'info'}
    const level = icons[this.props.level] || '';
    const className = 'info-box ' + level;
    if (this.props.errorId === 'slow_internet_connection') {
      return <SlowConnectionBanner errorText={this.props.text} />
    }

    const icon = LEVEL_ICONS[level];

    return (
      <div className={className}>
        <div className="icon">
          {icon ? <SvgIcon name={icon.name} viewBox={icon.viewBox} className={icon.className} /> : null}
        </div>
        <span>
          {this.props.text}
          {this.props.action ?
            <>
              &nbsp;&#32;<a href="#"
                style={{ whiteSpace: 'nowrap' }}
                onClick={(e) => {e.preventDefault(); this.props.action();}}>
                {this.props.actionText}
              </a>
            </>
          : null}
        </span>
        <div className="cancel"><MenuCancel onCancel={this.hide} /></div>
      </div>
    );
  }
};
